<script lang="ts">
  // Compliance Reports sub-panel per INTERFACE-SPECIFICATION.md §10.4.
  //
  // Structural shell with one report card per type. Report generation
  // (PDF / Markdown / JSON) ships with PR 5 alongside the audit-trail
  // tool; the cards here render their parameter controls so the
  // governance read-path is visible end-to-end.

  let quarter = $state<string>('Q3 2026');
  let from = $state<string>('2026-04-01');
  let to = $state<string>('2026-12-31');
</script>

<section>
  <h3 class="section-heading">Compliance reports</h3>
  <p class="muted">Pre-formatted reports with PDF / Markdown / JSON export. The export pipeline ships with PR 5 (audit-trail tooling); the parameter controls are wired today.</p>

  <ul class="reports-list">
    <li class="report-card">
      <header>
        <strong>Quarterly change summary</strong>
        <span class="muted">All catalogue changes effective in the selected quarter, grouped by jurisdiction-product, with the proposer / reviewer / substantiation chain.</span>
      </header>
      <label>
        <span class="muted">Quarter</span>
        <select bind:value={quarter}>
          <option>Q1 2026</option><option>Q2 2026</option><option>Q3 2026</option><option>Q4 2026</option>
        </select>
      </label>
      <button class="btn" type="button" disabled>Generate (PR 5)</button>
    </li>
    <li class="report-card">
      <header>
        <strong>Declared asymmetries report</strong>
        <span class="muted">All currently-declared asymmetries with substantiation date and rationale.</span>
      </header>
      <button class="btn" type="button" disabled>Generate (PR 5)</button>
    </li>
    <li class="report-card">
      <header>
        <strong>Emergency changes report</strong>
        <span class="muted">Changes with approval-to-effective interval under 14 days.</span>
      </header>
      <label>
        <span class="muted">From</span>
        <input type="date" bind:value={from} />
      </label>
      <label>
        <span class="muted">To</span>
        <input type="date" bind:value={to} />
      </label>
      <button class="btn" type="button" disabled>Generate (PR 5)</button>
    </li>
    <li class="report-card">
      <header>
        <strong>Authority register snapshot</strong>
        <span class="muted">The register frozen at a chosen date, for inclusion in compliance documents.</span>
      </header>
      <button class="btn" type="button" disabled>Generate (PR 5)</button>
    </li>
  </ul>
</section>

<style>
  .reports-list { list-style: none; padding: 0; margin: 0; display: flex; flex-direction: column; gap: var(--space-3); }
  .report-card {
    background: var(--surface-card);
    border: 1px solid var(--surface-line-soft);
    border-radius: var(--radius-md);
    padding: var(--space-4);
    display: flex;
    flex-direction: column;
    gap: var(--space-2);
  }
  .report-card header { display: flex; flex-direction: column; gap: var(--space-1); }
</style>
